<div class="w-full relative" [style.height]="height">
	<canvas #canvasRef></canvas>
</div>
